(() => {
  if (window.vorneuNavigationInitialized) return;
  window.vorneuNavigationInitialized = true;
  const observers = new Map();
  const measure = header => {
    const height = Math.ceil(header.getBoundingClientRect().height);
    document.documentElement.style.setProperty('--vn-header-height', `${height}px`);
    document.documentElement.style.setProperty('--vn-header-offset', header.dataset.vnSticky === 'false' ? '0px' : `${height}px`);
  };
  const init = scope => {
    const headers = [...scope.querySelectorAll('.vn-header')];
    if (scope.matches?.('.vn-header')) headers.unshift(scope);
    headers.forEach(header => {
      if (observers.has(header)) return;
      measure(header);
      const observer = window.ResizeObserver ? new ResizeObserver(() => measure(header)) : null;
      observer?.observe(header);
      observers.set(header, observer);
    });
  };
  document.addEventListener('click', event => {
    document.querySelectorAll('.vn-header details[open]').forEach(disclosure => {
      if (!disclosure.contains(event.target) || event.target.closest('a')) disclosure.open = false;
    });
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    const disclosure = event.target.closest('.vn-header details[open]');
    if (disclosure) {
      event.preventDefault();
      disclosure.open = false;
      disclosure.querySelector('summary')?.focus();
    }
  });
  document.addEventListener('focusout', event => {
    const header = event.target.closest('.vn-header');
    if (!header || !event.relatedTarget) return;
    header.querySelectorAll('details[open]').forEach(disclosure => {
      if (!disclosure.contains(event.relatedTarget)) disclosure.open = false;
    });
  });
  document.addEventListener('change', event => {
    if (event.target.matches('[data-vn-localize]')) event.target.form?.requestSubmit();
  });
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => {
    for (const [header, observer] of observers) {
      if (event.target === header || event.target.contains(header)) {
        observer?.disconnect();
        observers.delete(header);
      }
    }
    if (!observers.size) {
      document.documentElement.style.setProperty('--vn-header-height', '0px');
      document.documentElement.style.setProperty('--vn-header-offset', '0px');
    }
  });
  window.addEventListener('resize', () => observers.forEach((_, header) => measure(header)), { passive: true });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document));
  else init(document);
})();
